import { Col, Row, Space, Button } from "antd";
import { Form, Formik } from "formik";
import { useEffect, useState } from "react";

import { Input, RadioGroup, Select } from "components/form";
import styles from "../styles/EmployeeFilter.module.css";
import useStatusFlagOption from "components/elements/Select/StatusDropdown";
import { useTranslation } from "react-i18next";
import { Flex } from "antd/lib";
import localeTh from 'antd/es/date-picker/locale/th_TH';
import localeEn from 'antd/es/date-picker/locale/en_US';
import dayjs from "dayjs";
import FormAntd from "components/form/FormProvide/FormAntd";
import FormItem from "antd/es/form/FormItem";
import { FormDatePicker, FormSelect } from "components/form/FormProvide";


const EmployeeWorkInLeaveBenefitFilter = ({
  initialValues = {},
  // shiftOptions = [],
  // titleNameOptions = [],
  // employeeTypeOptions = [],
  // modifiedPositionOptions = [],
  // organizationUnderOptions = [],
  // welfareList = [],
  // welfareOption = [],
  // welfareTypeOptions = [],
  // dataFlag = null,
  // roleOption = [],
  // shiftDropDown = [],
  // selectedMenu = null,
  leaveGroupOptions = [],
  onCancel = () => { },
  onSubmit = () => { },
  onSearch = () => { },
}) => {
  const { i18n, t } = useTranslation();
  const [loading, setLoading] = useState(false);
  const [imageUrl, setImageUrl] = useState(null);
  console.log('leaveGroupOptions', leaveGroupOptions);


  const { modifiedStatus = [] } = useStatusFlagOption()
  function localeFn() {
    if (i18n.language == 'en') {
      return localeEn
    } else {
      return {
        ...localeTh,
        lang: {
          ...localeTh.lang,
          yearFormat: "BBBB",
          dateFormat: "D/M/BBBB",
          cellYearFormat: "BBBB"
        }
      }
    }
  }

  const handleChange = (event) => {
    console.log('year : ', dayjs(event).year());

    // setYear(dayjs(event).year());
    // onYearChange(dayjs(event).year(), pagination)
  };



  return (

    <FormAntd
      initialValues={initialValues}
      onFinish={(values) => {
        // console.log("values?.year", values?.year, values?.year?.year?.());

        onSearch({
          ...values,
          statusFlag: values?.statusFlag ? values?.statusFlag != "" ? values?.statusFlag : null : null,
          year: values?.year ? values?.year?.year?.() : dayjs().year()
        });
      }}

    // validationSchema={schema}
    >
      <FormItem shouldUpdate={(prev, curv) => {
        return prev['leaveTypeId'] != curv['leaveTypeId'] ||
          prev['taxId'] != curv['taxId'] || prev['passportNo'] != curv['passportNo']
      }}>
        {/* {({ resetForm, values = {}, setFieldValue = () => { }, setTouched = () => { } }) => { */}

        {({ getFieldValue, setFieldValue, resetFields }) => {
          return (

            <><Row gutter={[0, 16]} className={styles.filter}>
              {/* <Col span={6}>
      <Input
        name="commonTypeName"
        label={t(`masterdata.label.${selectedMenu}`)}
        placeholder={t(`masterdata.label.${selectedMenu}`)}
        size="large"
      />
    </Col>
    <Col span={6}>
      <Input
        name="description"
        label={t('masterdata.label.description')}
        placeholder={t('masterdata.label.description')}
        size="large"
      />
    </Col>
    <Col span={6}>
      <Input
        name="PayrollData"
        label={t('payrollData')}
        placeholder={t('payrollData')}
        size="large"
      />
    </Col> */}
              <Col span={8} style={{ paddingRight: "8px" }}>
                <div className={styles.container}>
                  {/* <Flex><span style={{ color: "#00275A" }}>{t('payroll.year')}</span></Flex> */}
                  <FormDatePicker
                    locale={localeFn()}
                    name="year"
                    dateFormat={"YYYY"}
                    picker="year"
                    label={t('leave-rights')}
                    allowClear
                    placeholder={t('report.all')}
                    size="large"
                    // value={values?.year ? moment(values?.year,"YYYY") : dayjs()}
                    onChange={(date) => {
                      if (date) {
                        const selectedYear = dayjs(date).year();
                        console.log('year', selectedYear);
                        setFieldValue('year', dayjs(date));
                      }
                    }} />
                </div>
              </Col>
              <Col span={8} style={{ padding: "0px 8px" }}>
                <FormSelect
                  name="leaveTypeId"
                  label={t('leave_type.label.leave_type')}
                  placeholder={t('common.pleaseSelect')}
                  size="large"
                  options={leaveGroupOptions.map(option => (
                    { value: option.value, label: option.label }))}
                  onChange={(e) => {
                    console.log('lllllleave', getFieldValue('leaveTypeId'))
                  }}
                  allowClear
                />
              </Col>
              <Col span={8} style={{ paddingLeft: "8px" }}>
                <FormSelect
                  name="statusFlag"
                  label={t('translation.status')}
                  placeholder={t('translation.status')}
                  size="large"
                  options={modifiedStatus} />
              </Col>
            </Row>

              <Row justify="end">
                <Space size={10} className={styles.filter}>
                  <Button type="default" onClick={() => { resetFields(); }} style={{ height: "40px", borderRadius: "8px" }}>
                    {t('common.clear').toUpperCase()}
                  </Button>
                  <Button type="primary" htmlType="submit" style={{ backgroundColor: "var(--button-color)", boxShadow: "none", height: "40px", borderRadius: "8px" }}>
                    {t("creatTamplete.Search").toUpperCase()}
                  </Button>
                </Space>
              </Row>
            </>
          );
        }}
      </FormItem>
    </FormAntd >
  );
};

export default EmployeeWorkInLeaveBenefitFilter;
